import React, { FC } from 'react';
import { Route, useLocation, RouteProps, Redirect } from 'react-router-dom';
import { useWeb3React } from '@web3-react/core';

interface PrivateRouteProps extends RouteProps {
  redirectTo: string;
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ children, redirectTo, ...props }) => {
  const location = useLocation();
  const { account } = useWeb3React();

  if (account) {
    return <Route {...props}>{children}</Route>;
  }

  return (
    <Redirect
      to={{
        pathname: redirectTo,
        state: {
          from: location.pathname,
        },
      }}
    />
  );
};
